export const QUESTION_BULK_TEMPLATE_CSV =
  "pillar,question_text,question_type,options,allow_multiple,include_in_lite\n" +
  "Strategic clarity,Leadership agrees on the top three value-creation priorities for the next 12 months.,rating,,N,Y\n" +
  "Scalable talent,Which talent gaps are most critical right now?,multiple_choice,Executive hiring|Succession planning|Role clarity|Capability building,Y,N\n" +
  "Relentless focus,What work should the team stop doing to protect focus?,open_ended,,N,N\n" +
  "Disciplined execution,How often does the leadership team review operating cadence?,dropdown,Weekly|Bi-weekly|Monthly|Quarterly,N,N\n" +
  "Energized culture,People feel safe raising risks and dissenting views.,rating,,N,Y\n" +
  "Financial performance,What is the expected hold period from today?,open_ended,,N,N\n";

export function downloadQuestionBulkTemplateCsv() {
  const blob = new Blob(["\ufeff" + QUESTION_BULK_TEMPLATE_CSV], {
    type: "text/csv;charset=utf-8",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "assessment-questions-template.csv";
  a.click();
  URL.revokeObjectURL(a.href);
}
